module.exports = __webpack_public_path__ + "media/ai_video_cyberpunk2.fc038bb2.mp4";